import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-bootstrap';

/*
  Class which defines a custom carousel of customer testimonials
  built using bootstrap's carousel and containing a panel of interactive logos.

  The content of the carousel has been defined in EmployerSignupPanel.jsx and
  is passed in as a prop (the testimonials), where
  this component is used to construct the employer registration page.

  The autoplay interval (the duration that needs to pass for the carousel to
  automatically cycle to the next panel) is also specified as a prop.
  This number is in milliseconds.
*/
var EmployerTestimonialCarousel = /*#__PURE__*/function (_Component) {
  function EmployerTestimonialCarousel(props) {
    var _this;
    _classCallCheck(this, EmployerTestimonialCarousel);
    _this = _callSuper(this, EmployerTestimonialCarousel, [props]);
    _this.state = {
      currentActiveIndex: 0,
      scheduledIncrements: []
    };
    _this.clearScheduledIncrements = _this.clearScheduledIncrements.bind(_this);
    _this.setCurrentActiveIndex = _this.setCurrentActiveIndex.bind(_this);
    _this.renderLogoPanel = _this.renderLogoPanel.bind(_this);
    _this.renderCarousel = _this.renderCarousel.bind(_this);
    _this.incrementActiveIndex = _this.incrementActiveIndex.bind(_this);
    var newAutoplayEvent = window.setTimeout(_this.incrementActiveIndex, _this.props.interval);
    _this.state.scheduledIncrements.push(newAutoplayEvent);
    return _this;
  }
  _inherits(EmployerTestimonialCarousel, _Component);
  return _createClass(EmployerTestimonialCarousel, [{
    key: "setCurrentActiveIndex",
    value: function setCurrentActiveIndex(newActiveIndex) {
      var _this$props = this.props,
        interval = _this$props.interval,
        testimonials = _this$props.testimonials;
      if (newActiveIndex < 0 || newActiveIndex >= testimonials.length) {
        return;
      }
      this.setState({
        currentActiveIndex: newActiveIndex
      });
      var newAutoplayEvent = window.setTimeout(this.incrementActiveIndex, interval);
      this.state.scheduledIncrements.push(newAutoplayEvent);
    }
  }, {
    key: "clearScheduledIncrements",
    value: function clearScheduledIncrements() {
      this.state.scheduledIncrements.map(function (increment) {
        return window.clearTimeout(increment);
      });
      this.state.scheduledIncrements.slice(0, this.state.scheduledIncrements.length);
    }
  }, {
    key: "incrementActiveIndex",
    value: function incrementActiveIndex() {
      var testimonials = this.props.testimonials;
      var activeIndex = this.state.currentActiveIndex;
      var newActiveIndex = activeIndex === testimonials.length - 1 ? 0 : activeIndex + 1;

      // Notice that this call will schedule a timeout event 15 s from now.
      // This is 100% intentional and creates the infinite autoplay
      // effect for the carousel.
      this.setCurrentActiveIndex(newActiveIndex);
    }
  }, {
    key: "renderLogoPanel",
    value: function renderLogoPanel() {
      var _this2 = this;
      var testimonials = this.props.testimonials;
      return /*#__PURE__*/React.createElement("div", {
        className: "logo-panel"
      }, testimonials.map(function (testimony, index) {
        return /*#__PURE__*/React.createElement("div", {
          role: "button",
          tabIndex: index,
          onClick: function onClick() {
            _this2.clearScheduledIncrements();
            _this2.setCurrentActiveIndex(index);
          }
        }, /*#__PURE__*/React.createElement("img", {
          className: "logo",
          src: index === _this2.state.currentActiveIndex ? testimony.activeLogo : testimony.inactiveLogo,
          alt: "Company Logo",
          width: testimony.logoWidth,
          height: testimony.logoHeight
        }));
      }));
    }
  }, {
    key: "renderCarousel",
    value: function renderCarousel() {
      var _this3 = this;
      var testimonials = this.props.testimonials;
      return /*#__PURE__*/React.createElement(Carousel, {
        activeIndex: this.state.currentActiveIndex,
        controls: false,
        touch: true,
        onSelect: function onSelect(carouselPageIndex) {
          _this3.clearScheduledIncrements();
          _this3.setCurrentActiveIndex(carouselPageIndex);
        }
      }, testimonials.map(function (testimony) {
        return /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
          className: "visible-750-1k"
        }, /*#__PURE__*/React.createElement("div", {
          className: "logo"
        }, /*#__PURE__*/React.createElement("img", {
          src: testimony.activeLogo,
          alt: "Company Logo"
        }))), /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 employer-testimonial-blurb"
        }, "\u201C", testimony.body, "\u201D"), /*#__PURE__*/React.createElement("div", {
          className: "employer-testimonial-byline"
        }, /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 employer-name"
        }, testimony.managerName), /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 employer-title"
        }, testimony.managerTitle)));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "employer-testimonial-carousel"
      }, this.renderLogoPanel(), this.renderCarousel());
    }
  }]);
}(Component);
EmployerTestimonialCarousel.propTypes = {
  testimonials: PropTypes.arrayOf(PropTypes.shape({
    managerName: PropTypes.string.isRequired,
    managerTitle: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    activeLogo: PropTypes.string.isRequired,
    inactiveLogo: PropTypes.string.isRequired,
    logoWidth: PropTypes.number.isRequired,
    logoHeight: PropTypes.number.isRequired
  })),
  interval: PropTypes.number
};
EmployerTestimonialCarousel.defaultProps = {
  testimonials: [],
  interval: 15000
};
export default EmployerTestimonialCarousel;